import { withNamespaces } from "react-i18next";
import { TableWithPagination } from "../../../components";
import { getItemConditionOptionHeading, ItemConditionOptionDataType, ItemConditionOptionPath } from "../../../utils";


const Table = ({
    handleIcon = () => false,
    list = [],
    handlePagination = () => false,
    handleChangeLimit = () => false,
    page = "",
    limit = "",
    t
}) => {

    const heading = getItemConditionOptionHeading(t)

    return (

        <TableWithPagination
            heading={heading}
            rows={list?.list}
            path={ItemConditionOptionPath}
            dataType={ItemConditionOptionDataType}
            showpagination={true}
            count="2"
            showpdfbtn={false}
            showexcelbtn={false}
            showSearch={false}
            tableType="no-side"
            handleIcon={handleIcon}
            view={true}
            handlePagination={handlePagination}
            handleChangeLimit={handleChangeLimit}
            totalRowsCount={list?.count}
            page={page}
            limit={limit}
            delete={false}
            height={`calc(100vh - 300px)`}
        />
    )
}
export default withNamespaces("inspectionItemmaster")(Table); 